// extracted by mini-css-extract-plugin
export default {"title":"styles_title__dKmUq","summary-value":"styles_summary-value__LsWZ3"};